const aboutHeader = {
    ru: {
        aboutHeader: "О нас"
    },
    eng: {
        aboutHeader: "About us"
    },
    az: {
        aboutHeader: 'Haqqımızda'
    }
}

export default aboutHeader